import { FC } from 'react';

export const SkewedBadge: FC<{
  color: string;
  border: string;
  label: string;
}> = ({ color, border, label }) => (
  <div
    style={{
      background: color,
      border: `2px solid ${border}`,
      color: '#fff',
      padding: '4px 12px',
      borderRadius: 4,
      fontSize: 11,
      fontWeight: 600,
      marginTop: 8,
      transform: 'skew(-10deg)',
      textTransform: 'uppercase',
      width: '100%',
      textAlign: 'center',
      boxSizing: 'border-box',
    }}
  >
    <span style={{ transform: 'skew(10deg)', display: 'inline-block' }}>
      {label}
    </span>
  </div>
);
